import { z } from 'zod';
const oneArc = (shape) => z.object(shape).refine((v) => [v.leadId, v.contactId, v.companyId, v.opportunityId, v.taskId].filter(Boolean).length === 1, {
    message: 'A note must relate to exactly one record',
});
/** docs section 16 "Notes": rich text, author, timestamp, editing, history,
 * @mentions. `bodyJson` is the rich-text document (ProseMirror-shaped) the
 * editor produces; `mentionedMembershipIds` is what the editor's @mention
 * picker resolved — the server never parses free text for names. */
export const createNoteSchema = oneArc({
    bodyJson: z.record(z.string(), z.unknown()),
    bodyHtml: z.string().trim().min(1).max(20_000),
    mentionedMembershipIds: z.array(z.string().uuid()).max(20).default([]),
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    opportunityId: z.string().uuid().optional(),
    taskId: z.string().uuid().optional(),
});
export const updateNoteSchema = z.object({
    bodyJson: z.record(z.string(), z.unknown()),
    bodyHtml: z.string().trim().min(1).max(20_000),
    mentionedMembershipIds: z.array(z.string().uuid()).max(20).default([]),
    version: z.number().int().nonnegative(),
});
export const listNotesQuerySchema = z
    .object({
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    opportunityId: z.string().uuid().optional(),
    taskId: z.string().uuid().optional(),
})
    .refine((v) => Boolean(v.leadId || v.contactId || v.companyId || v.opportunityId || v.taskId), {
    message: 'At least one record reference is required',
});
export const noteResponseSchema = z.object({
    id: z.string().uuid(),
    bodyHtml: z.string(),
    bodyJson: z.record(z.string(), z.unknown()),
    pinned: z.boolean(),
    author: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
    mentionedMembershipIds: z.array(z.string().uuid()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    version: z.number().int(),
});
//# sourceMappingURL=schemas.js.map